import { PromoCodeCreatedBy, PromoCodeTag } from '../../../../../../services/exports/Constants';

export default {
  title: 'Promo codes',
  tabs: {
    active: 'Aktiv',
    expired: 'Ausgelaufen',
    email_sign_up: 'Promo-E-Mail-Anmeldung',
  },
  show_master_promo_code: 'Zeigen Sie den Kunden den Master-Promo-Code',
  send_rejected_order_apologies_promo_code:
    'Senden einen Promo-Code an Kunden, wenn die Bestellung manuell abgelehnt wird.',
  filters: {
    tag: {
      placeholder: 'Tag',
      options: {
        [PromoCodeTag.Master]: 'Master',
        [PromoCodeTag.Campaign]: 'Kampagne',
        [PromoCodeTag.OneTime]: 'Einmalig',
      },
    },
    code: {
      placeholder: 'Code',
    },
    campaign: {
      placeholder: 'Kampagne',
    },
    created_by: {
      placeholder: 'Erstellt von',
      options: {
        [PromoCodeCreatedBy.User]: 'Benutzer',
        [PromoCodeCreatedBy.System]: 'System',
      },
    },
  },
  fields: {
    code: 'Code',
    tag: 'Tag',
    type: 'Typ',
    discount_type: 'Rabattart',
    discount: 'Rabatt',
    usage_threshold: 'Mindestbestellwert',
    quantity: 'Anzahl',
    expires_at: 'Läuft ab',
    level: 'Ebene',
    max_discount: 'Maximaler Rabatt',
    created_by: 'Erstellt von',
    image: 'Bild',
  },
  tags: {
    [PromoCodeTag.Master]: 'Master',
    [PromoCodeTag.Campaign]: 'Kampagne',
    [PromoCodeTag.OneTime]: 'Einmalig',
  },
  types: {
    single_use: 'Einmalige Nutzung',
    multi_use: 'Mehrfachnutzung',
    unknown: 'Unbekannt',
  },
  discount_types: {
    fixed_amount: 'Fester Betrag',
    percentage: 'Prozent %',
    unknown: 'Unbekannt',
  },
  created_by: {
    [PromoCodeCreatedBy.User]: 'Benutzer',
    [PromoCodeCreatedBy.System]: 'System',
  },
  labels: {
    discount: 'Rabatt',
    usage_threshold: 'Mindestbestellwert',
    company: 'Unternehmen',
    restaurant: 'Restaurant',
    restaurant_group: 'Marke',
  },
  buttons: {
    add: 'Hinzufügen',
    edit: 'Bearbeiten',
    delete: 'Löschen',
    restore: 'Wiederherstellen',
    add_promo_code: 'Promo Code hinzufügen',
    images: 'Bild verwalten',
  },
  toasts: {
    failed_to_load_data: 'Daten konnten nicht geladen werden',
    failed_to_save_settings: 'Speichern der Änderungen fehlgeschlagen',
    failed_to_delete_promo_code: 'Promo Code löschen fehlgeschlagen',
    failed_to_restore_promo_code: 'Promo Code wiederherstellen fehlgeschlagen',
    promo_code_got_deleted: 'Promo Code wurde gelöscht',
    promo_code_got_restored: 'Promo Code wurde wiederhergestellt',
  },
  delete_confirmation: {
    title: 'Promo Code löschen?',
    buttons: {
      yes: 'Ja',
      no: 'Nein',
    },
  },
  restore_confirmation: {
    title: 'Promo Code wiederherstellen?',
    buttons: {
      yes: 'Ja',
      no: 'Nein',
    },
  },
};
